<template>
  <section id="infoCalls">
    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="rangeDialogActive"
      :active="rangeDialogActive"
      module="agentsCallsInformation"
      @dialog:change="eventdialog"
    ></RangeDateDialog>

    <v-card class="shadow-1 mt-5">
      <v-tabs v-model="tab" dark background-color="secondary lighten-1" hide-slider grow>
        <v-tab
          v-for="(item, index) in tabHeaders"
          :key="index"
          @click="getCallsInfo(index)"
        >
          <v-slide-x-transition>
            <v-icon left v-if="tab === index">mdi-check-circle-outline</v-icon>
          </v-slide-x-transition>
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabHeaders" :key="item">
          <v-card flat>
            <v-skeleton-loader v-if="isLoading" type="table"> </v-skeleton-loader>
            <v-row dense justify="end" v-else>
              <v-col cols="12">
                <v-container class="px-md-7" fluid v-if="customSearchInfo">
                  <v-row dense justify="space-between">
                    <v-col cols="12" md="auto">
                      <span class="blue-grey--text text--darken-3">
                        <span class="caption grey--text">Tipo</span>
                        {{
                          customSearchInfo.call == null
                            ? "Todas"
                            : customSearchInfo.call === 1
                            ? "Salientes"
                            : "Entrantes"
                        }}
                      </span>
                    </v-col>

                    <v-col cols="12" md="auto">
                      <span class="blue-grey--text text--darken-3">
                        <span class="caption grey--text">Desde</span>
                        {{ customSearchInfo.start }}
                      </span>
                      <span class="blue-grey--text text--darken-3">
                        <span class="caption grey--text">Hasta</span>
                        {{ customSearchInfo.end }}
                      </span>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider v-if="customSearchInfo"></v-divider>
              </v-col>
              <v-col cols="12">
                <vuescroll
                  :ops="{
                    bar: {
                      background: '#bacfcec0',
                      keepShow: true,
                    },
                  }"
                >
                  <v-data-table
                    :headers="overviewHeaders"
                    :items="overviewItems"
                    class="elevation-0"
                    :items-per-page="15"
                    hide-default-footer
                  >
                    <template v-slot:[`item.total`]="{ item }">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.total }}
                            <span class="caption grey--text">total</span>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <span>
                              <v-icon x-small color="teal">mdi-phone</v-icon>
                              {{ item.contestada }}
                            </span>
                            &mdash;
                            <span>
                              <v-icon x-small color="red">mdi-call-missed</v-icon>
                              {{ item.total - item.contestada }}
                            </span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>

                    <template v-slot:[`item.atencion`]="{ item }">
                      <span class="d-inline d-md-none pr-2">
                        {{ getAttentionPercentage(item.contestada, item.total) }}
                      </span>

                      <v-progress-circular
                        size="23"
                        :value="getAttentionPercentage(item.contestada, item.total)"
                        color="info"
                      ></v-progress-circular>

                      <span class="d-none d-md-inline pl-2">
                        {{ getAttentionPercentage(item.contestada, item.total) }}
                      </span>
                    </template>

                    <template v-slot:[`item.duracion`]="{ item }">
                      <span>
                        {{ item.duracion | secondsToTimeFormat }}
                      </span>
                    </template>

                    <template v-slot:[`item.maxima`]="{ item }">
                      <span>
                        {{ item.maxima | secondsToTimeFormat }}
                      </span>
                    </template>

                    <template v-slot:[`item.hablado`]="{ item }">
                      <span>
                        {{ item.hablado | secondsToTimeFormat }}
                      </span>
                    </template>
                  </v-data-table>
                </vuescroll>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";

import RangeDateDialog from "../../DatePickers/DateRangePicker";

export default {
  name: "ActivityOverview",
  inject: ["theme"],
  components: {
    RangeDateDialog,
    vuescroll,
  },
  data() {
    return {
      isLoading: false,
      //Request
      infoUrl: `${process.env.VUE_APP_ROOTAPI}`,
      accessToken: localStorage.getItem("token"),
      rangeDialogActive: false,
      axiosInstance: null,
      customParameters: {},
      customSearchInfo: null,
      //Tabs
      tab: null,
      tabHeaders: ["Diario", "Personalizado"],
      // Table Data
      overviewHeaders: [
        { text: "Extensión", value: "extencion", width: "10%" },
        {
          text: "Llamadas",
          align: "right",
          value: "total",
          width: "20%",
        },
        {
          text: "% Atención",
          value: "atencion",
          sortable: false,
          width: "15%",
        },
        {
          text: "Duración",
          align: "right",
          value: "duracion",
          width: "15%",
        },
        {
          text: "T. hablado",
          align: "right",
          value: "hablado",
          width: "15%",
        },
        {
          text: "Llamada máx.",
          align: "right",
          value: "maxima",
          width: "15%",
        },
      ],
      overviewItems: [],
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },
  },

  created() {
    this.axiosInstance = axios.create({
      baseURL: this.infoUrl,
      headers: {
        Authorization: `Bearer ${this.accessToken}`,
      },
    });
    this.getCallsInfo(0);
  },

  methods: {
    /**
     * [Obtener porcentaje de atención]
     * @param {string} value [llamadas entrantes]
     * @param {string} total [total de llamadas]
     */
    getAttentionPercentage(value, total) {
      let result = (100 * value) / total;

      return result.toFixed() + "%";
    },

    /**
     * Busca los datos de las llamadas
     * @param {Number} index - Indice de la Tab
     */
    async getCallsInfo(index) {
      this.isLoading = true;
      if (index === 1) this.rangeDialogActive = true;
      else {
        try {
          const { data } = await this.axiosInstance.get(
            `/agents/sumary/details_call_agent`
          );
          // console.log(data);
          this.customSearchInfo = null;
          this.overviewItems = data;
        } catch (errors) {
          if (errors.response.status === 401) {
            this.$snotify.error("Su sesion ha finalizado.", "Error");
            this.$store.dispatch("passport/RESET_AUTH");
            this.$router.push({ name: "login" });
            return;
          }
          console.log(errors);
        }
        this.isLoading = false;
      }
      return;
    },

    /**
     * [Obtener estado en español]
     * @param {string} state [Estado de la llamada]
     */
    getSpanishState(state) {
      if (state == "ANSWERED") {
        return {
          text: "Contestada",
          color: "success",
          icon: "mdi-phone-outline",
        };
      } else {
        return {
          text: "No contestada",
          color: "error",
          icon: "mdi-call-missed",
        };
      }
    },

    async eventdialog(data, parameters) {
      this.rangeDialogActive = false;
      if (data !== "cerrar") {
        this.isLoading = true;
        try {
          const { data } = await this.axiosInstance.post(
            `/agents/sumary/details_call_agent_custom`,
            parameters
          );
          // console.log("DATA CUSTOM", data)
          this.overviewItems = data;
          this.customParameters = parameters;
          this.customSearchInfo = parameters;
        } catch (err) {
          console.log(err);
        }
        this.isLoading = false;
      } else {
        this.tab = 0;
        this.getCallsInfo(0);
      }
      return;
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}

audio {
  height: 35px !important;
}
</style>
